{
  "SLUDGE" : [
    "13.07.03*"
  ],
  "FUEL_REMNANTS" : [
    "13.07.01*"
  ],
  "BILGE_WATER" : [
    "13.04.01*",
    "13.04.02*",
    "13.04.03*"
  ],
  "USED_ENGINE_OIL" : [
    "13.02.04*",
    "13.02.05*",
    "13.02.06*",
    "13.02.07*",
    "13.02.08*"
  ],
  "DIRTY_BALLASTWATER" : [
    "16.10. 01*"
  ],
  "WASHWATER_OIL" : [
    "16.07.08*"
  ],
  "OILY_WASTE_FROM_CLEANING" : [
    "16.07.08*"
  ],
  "OTHER_OILY_WASTE" : [],
  "CARGO_RESIDUES_OR_WASHWATER" : [
    "16.07.09*"
  ],
  "DIRTY_BALLASTWATER_CHEMICALS" : [
    "16.10.01*"
  ],
  "OTHER_CARGO_RESIDUES" : [
    "16.03.03*",
    "16.03.05*"
  ],
  "SEWAGE_WASTE_BLACK" : [
    "20.03.04"
  ],
  "SEWAGE_WASTE_GREY" : [
    "20.03.04"
  ],
  "FOOD_WASTE" : [
    "20.01.08"
  ],
  "PLASTIC_ANY" : [],
  "PLASTIC_CLEAN" : [
    "20.01.39",
    "15.01.02"
  ],
  "PLASTIC_CONTAMINATED" : [
    "15.01.10*",
    "15.01.02",
    "20.01.39"
  ],
  "SMALL_DANGEROUS_WASTE" : [],
  "OTHER_DOMESTIC_WASTE" : [
    "20.03.01"
  ],
  "INTERNATIONAL_CATERING_WASTE" : [
    "20.01.08"
  ],
  "PAPER_OR_CARTON" : [
    "20.01.01"
  ],
  "RAGS" : [
    "15.02.02*"
  ],
  "GLASS" : [
    "20.01.02",
    "15.01.07"
  ],
  "METAL_OR_STEELWIRES" : [
    "20.01.40"
  ],
  "BOTTLES" : [
    "15.01.02",
    "15.01.07"
  ],
  "CROCKERY" : [
    "20.01.99"
  ],
  "INCINERATOR_ASHES" : [
    "19.01.11*",
    "19.01.12"
  ],
  "ANIMAL_CARCASSES" : [
    "02.01.02"
  ],
  "EWASTE_WHOLE_DEVICES" : [
    "16.02.11*",
    "16.02.12*",
    "16.02.13*",
    "16.02.14",
    "16.02.15*",
    "16.02.16"
  ],
  "EWASTE_DEVICES" : [
    "20.01.23*",
    "20.01.35*",
    "20.01.36"
  ],
  "PYROTECHNICS" : [
    "16.04.02*",
    "16.04.03*"
  ],
  "BATTERIES" : [
    "16.06.01*"
  ],
  "FIRE_EXTINGUISHERS" : [
    "16.05.05"
  ],
  "CAR_TYRES_OR_RUBBER" : [
    "16.01.03"
  ],
  "COOLING_LIQUIDS" : [
    "14.06.02*",
    "14.06.03*",
    "20.01.13*"
  ],
  "PROPELLER_SHAFT_GREASE" : [
    "13.08.99*"
  ],
  "FUMIGATION_PRODUCTS" : [
    "20.01.29*",
    "20.01.30"
  ],
  "FILTER_OR_RAGS_BAGS" : [
    "15.02.02*"
  ],
  "WOOD" : [
    "20.01.37*",
    "20.01.38"
  ],
  "OIL_CONTAMINATED_DRUMS" : [
    "15.01.10*"
  ],
  "FISHING_GEAR" : [
    "02.01.99"
  ],
  "COOKING_OIL" : [
    "20.01.25"
  ],
  "OPERATIONAL_WASTE" : [],
  "WASHWATER_DRY_CARGO_HME" : [
    "16.07.09*"
  ],
  "WASHWATER_DRY_CARGO_NON_HME" : [
    "16.07.09*",
    "16.07.99"
  ],
  "DRY_CARGO_RESIDUES_HME" : [
    "16.03 .03*",
    "16.03.05*"
  ],
  "DRY_CARGO_RESIDUES_NON_HME" : [
    "16.03.03*",
    "16.03.04",
    "16.03.05*",
    "16.03.06"
  ],
  "OTHER_CARGO_RESIDUES_NON_TANKERS" : []
}
